export default {
  ['title']: 'CATEGORIES INTRODUCTION',
  ['sub-title']: 'ENTERPRISE & PRODUCT INTRODUCTION'
}
